import { Reporter, visibilityObserver } from 'features/dataCapture';
import { utagLinkLanding } from 'features/tealium';
import relatedVideos from 'features/relatedVideos/desktop';
import { checkIfVideoAPIReady, VideoPlayer, injectYouTubeIframeAPI } from 'features/youtube';
import { prefetchWebpackAssetSet } from 'features/webpack';
import { initCategorySearch } from 'features/search/categorySearch';

import getRecommendedItems from '../../_client/features/certona/desktop';
import { initializeTrimHybridContent } from '../hybridContent';

$(() => {

	const $playerDiv = $('#jsVideo');
	const searchSelector = '#searchCategory';
	const searchBtnSelector = '#searchBtnCategory';
	const searchEl = document.querySelector(searchSelector);
	const searchBtnEl = document.querySelector(searchBtnSelector);

	if (searchEl && searchBtnEl) {

		initCategorySearch(searchSelector, searchBtnSelector);

	}

	function initLandingPageVideo () {

		// get video id from player div
		const videoId = $playerDiv.attr('data-videoid');

		// set video options here
		const options = {
			videoId,
			width: 560,
			height: 315,
			playerVars: {
				rel: 0
			}
		};

		checkIfVideoAPIReady().then(() => VideoPlayer('jsVideo', options));

	}

	if (window.isIpad()) {

		$('.noTouch').removeClass('noTouch');
		const rightLpContainer = document.querySelector('.rightLpContainer');
		if (rightLpContainer) {

			rightLpContainer.classList.add('ipadContainer');

		}

	}

	$('.crystal, .finish').click(function () {

		const pageReplace = $(this).hasClass('crystal') ? 'crystalDefault.aspx?' : 'finishDefault.aspx?';
		const strReplace = $(this).hasClass('crystal') ? 'Grade' : 'ID';
		const url =			pageReplace
			+ $(this)
				.attr('rel')
				.replace(/#/, '')
				.replace(/_/, '=')
				.replace(/Detail/, strReplace);
		if ($(this).hasClass('crystal')) {

			$(this).lpModal({
				onInit: true,
				width: 630,
				height: 390,
				src: url
			});

		} else {

			$(this).lpModal({
				onInit: true,
				width: 630,
				height: 380,
				src: url
			});

		}

		return false;

	});

	$('.scrollable').scrollable();

	let dataCaptureObserver;
	const observeAndTrackElements = (skuViews) => {

		if (skuViews.length > 0) {

			if (!dataCaptureObserver) {

				const { reporter } = window.lp.dataCapture;

				dataCaptureObserver = visibilityObserver((element) => {

					const data = Reporter.getSkuViewData(element);
					reporter.track(data);

				});

			}
			skuViews.forEach((element) => dataCaptureObserver.observe(element));

		}

	};

	// Certona
	if (window.lp.globals.canShowCertona) {

		if (window.lp.globals.enableDataCapture) {

			// More You May Like tracking
			document.addEventListener('recommendedItems:categorylanding:loaded', () => {

				observeAndTrackElements(document.querySelectorAll('.sortMYMLProdContainer img[data-sku]'));

			});

		}
		window.lp.certona.getRecommendedItems = getRecommendedItems;
		window.lp.certona.getRecommendedItems();

		document.addEventListener('recommendedItems:categorylanding02:loaded', () => {

			const trendingItems = document.querySelectorAll('.sortTrendingProdContainer');
			const { product_category: category } = window.utag_data;

			// data capture
			observeAndTrackElements(document.querySelectorAll('.sortTrendingProdContainer img[data-sku]'));

			trendingItems.forEach((ti) => {

				ti.addEventListener(
					'click',
					(e) => {

						utagLinkLanding('Landing Page')({
							eventAction: `Click-Trending-${category}`,
							eventLabel: e.target.getAttribute('data-sku')
						});

					},
					{
						once: true
					}
				);

			});

		});

	}

	if ($playerDiv.length > 0) {

		injectYouTubeIframeAPI();
		initLandingPageVideo();

	}

	// initiate related video widget if we have data for it
	if (document.getElementById('relatedVideosSection')) {

		injectYouTubeIframeAPI();
		relatedVideos().init();

	}

	prefetchWebpackAssetSet('desktop/sort');

	initializeTrimHybridContent('landingPagehybridContent');

});
